import React from 'react';
import './NnPianoKeyboard.scss';
import NnPianoKey from './NnPianoKey';
import NnKeyConstants from '../music/NnKeyConstants';
import NnPianoOctaveSelector from './NnPianoOctaveSelector';

class NnPianoKeyboard extends React.Component {
  constructor(props) {
    super(props);

    this.renderKey = this.renderKey.bind(this);
  }

  render() {
    const {letters, octave, onOctavePress} = this.props;
    return (
      <div>
        <NnPianoOctaveSelector octave={octave} onClick={onOctavePress} letters={letters}/>
        <div className="keyboard-panel">
            { NnKeyConstants.keyNames.map(this.renderKey) }
        </div>
      </div>
    );
  }

  renderKey = (keyName) => {
    let activeKeyName = this.props.note && this.props.note.name
    return (
      <NnPianoKey
        active={activeKeyName === keyName}
        black={keyName.length > 1}
        letters={this.props.letters}
        key={keyName}
        keyName={keyName}
        octave={this.props.octave}
        onKeyPress={this.props.onKeyPress}>
      </NnPianoKey>
    )
  }
}

export default NnPianoKeyboard;
